/* ============================================================
   Case studies carousel — Swiper 11 (bundled per page)
   ------------------------------------------------------------
   Swiper is `import`ed from the npm ESM build, so esbuild bundles
   it straight into this page's JS — it only ships on pages whose
   entry imports this component (see case-studies.css / .case-studies-swiper).
   The ESM build is modular: register only the features we use
   (Navigation) so unused Swiper modules are tree-shaken out.
   ============================================================ */
import Swiper from "swiper";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";

export function initportfolioCarousel() {
  const el = document.querySelector(".portfolio-carousel");
  if (!el) return;

  new Swiper(el, {
    modules: [Navigation, EffectFade, Autoplay],

    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 600,

    autoplay: {
      delay: 3000, 
      disableOnInteraction: false, 
      pauseOnMouseEnter: true, 
    },

    navigation: {
      prevEl: "[data-case-prev]",
      nextEl: "[data-case-next]",
    },
  });
}